import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { reduxKey } from './constants';
import { setWatchingState, clickWatch, requestFailure, requestSuccess } from './actionCreators';
import { handleActions } from 'redux-actions';
function setUserState(state, username, value) {
    if (!username) {
        return state;
    }
    const normalizedUsername = username.toLowerCase();
    return _object_spread_props(_object_spread({}, state), {
        [normalizedUsername]: _object_spread({}, state[normalizedUsername], value)
    });
}
const actionHandlers = handleActions({
    [clickWatch.toString()]: (state, { payload: { user: { username } } })=>setUserState(state, username, {
            isLoading: true
        }),
    [requestFailure.toString()]: (state, { payload: { username } })=>setUserState(state, username, {
            isLoading: false
        }),
    [requestSuccess.toString()]: (state, { payload: { username, isWatching } })=>setUserState(state, username, {
            isLoading: false,
            isWatching
        }),
    [setWatchingState.toString()]: (state, { payload: { username, isWatching } })=>setUserState(state, username, {
            isLoading: false,
            isWatching
        })
}, {});
export default {
    [reduxKey]: actionHandlers
};

//# sourceMappingURL=reducers.js.map